import type {UploadMediaInputProps} from '@Panels/user-media-panel/components/upload-media-input';

export interface NoBrandLogosProps {
  /** The panel's upload wiring; the empty state adds the brand-logo source and the image file types. */
  uploadInputProps: Omit<UploadMediaInputProps, 'children' | 'uploadSource' | 'uploadAcceptedMimetype'>;
}

export const EMPTY_BRAND_LOGOS_ILLUSTRATION_PATH = 'poster-editor-thumbnails/empty-logos-infographic.png';
export const EMPTY_BRAND_LOGOS_ILLUSTRATION_WIDTH = '170px';
export const BRAND_LOGO_ACCEPTED_MIMETYPE = 'image/*';
